// extracted by mini-css-extract-plugin
module.exports = {"iconAttendees":"SidebarModerator_iconAttendees__1gc7X","iconChat":"SidebarModerator_iconChat__2TRgx","disabled":"SidebarModerator_disabled__1kflI"};